import { render, staticRenderFns } from "./StatValueDisplay.vue?vue&type=template&id=52c85f06&scoped=true&"
import script from "./StatValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./StatValueDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c85f06",
  null
  
)

export default component.exports